import type { SyntheticEvent, KeyboardEvent } from 'react';
import { notify } from '@/lib/notify.js';

/** Keep unavailable setup controls focusable and explain their prerequisite before an effect. */
export function generationActionGuard(blocked: unknown, message: string) {
  const stop = (event: SyntheticEvent) => {
    if (!blocked) return;
    event.preventDefault();
    event.stopPropagation();
  };
  return {
    onPointerDownCapture: stop,
    onClickCapture: (event: SyntheticEvent) => {
      if (!blocked) return;
      stop(event);
      notify.error(message);
    },
    onKeyDownCapture: (event: KeyboardEvent) => {
      const activatesControl = ['Enter', ' ', 'ArrowDown', 'ArrowUp'].includes(
        event.key,
      );
      const typesAhead =
        event.key.length === 1 &&
        !event.ctrlKey &&
        !event.altKey &&
        !event.metaKey;
      if (!blocked || (!activatesControl && !typesAhead)) return;
      stop(event);
      notify.error(message);
    },
  };
}
